























































































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class RemaxToolbarActions extends Vue {

    public widthThresholdValue: number = 1100;
    public heightThresholdValue: number = 400;

    get isLoggedIn(): boolean {
        return this.$store.state.isLoggedIn;
    }

    public externalLink(url: string) {
        window.location.href = url;
    }

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    public onSignInOrOut() {
        if (this.isLoggedIn) {
                this.$q.dialog({
                    title: '',
                    message: 'Are you sure you want to sign out?',
                    cancel: true,
                    persistent: true,
                }).onOk(() => {
                    // console.log('>>>> OK')
                    this.$store.dispatch('logout');
                }).onCancel(() => {
                    // console.log('>>>> Cancel')
                }).onDismiss(() => {
                    // console.log('I am triggered on both OK and Cancel')
                });
        } else {
            this.$store.dispatch('login');
        }
    }
}

